import { tracked } from "@glimmer/tracking";
import { Task, task } from "ember-concurrency";
import Component from "@glimmer/component";
import { service } from "@ember/service";
import { arg } from "glesys-controlpanel/utils/arg";
import { arrayOf, shape, instanceOf } from "prop-types";
import DataCenter from "glesys-controlpanel/models/data-center";
import PrivateNetworkModel from "glesys-controlpanel/models/private-network";

export default class ModalsPrivateNetworkCreateSegment extends Component {
  @service modal;

  @tracked name;
  @tracked platform = "KVM";
  @tracked dataCenter;

  ipv4subnet = "192.168.0.0/24";

  @arg(
    shape({
      privateNetwork: instanceOf(PrivateNetworkModel).isRequired,
      task: instanceOf(Task).isRequired,
      dataCenters: arrayOf(instanceOf(DataCenter)).isRequired,
    }).isRequired,
  )
  params;

  constructor() {
    super(...arguments);
    this.dataCenter = this.dataCenters.at(0);
  }

  get task() {
    return this.params.task;
  }

  get platforms() {
    return [{ value: "KVM" }, { value: "VMware" }];
  }

  get dataCenters() {
    return this.params.dataCenters;
  }

  get dataCenterOptions() {
    return this.dataCenters.map((dataCenter) => ({
      value: dataCenter.id,
      label: dataCenter.name,
    }));
  }

  get validationErrors() {
    return !this.name || !this.platform || !this.dataCenter || !this.ipv4subnet;
  }

  onChange = ({ name, platform, ipv4subnet, dataCenter }) => {
    this.name = name;
    this.platform = platform;
    this.ipv4subnet = ipv4subnet;
    this.dataCenter = this.dataCenters.find((dc) => dc.id === dataCenter);
  };

  submitTask = task(async () => {
    let { name, platform, dataCenter, ipv4subnet } = this;
    await this.task.perform({ name, platform, dataCenter, ipv4subnet });

    this.modal.close();
  });
}
